import 'react-chrono/dist/style.css';
import './src/styles/global.css';
